import { render, staticRenderFns } from "./ChartjsBarChart.vue?vue&type=template&id=617a6f1a&scoped=true&"
import script from "./ChartjsBarChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChart.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChartjsBarChart.vue?vue&type=style&index=1&id=617a6f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a6f1a",
  null
  
)

export default component.exports